export { default as ServiceAreasFAQSection } from './faq-section';
